import React, { useEffect, useState } from "react";
import { AIChatbot } from "../ai-chatbot";
import { ArrowUpIcon } from "@radix-ui/react-icons";
import { Button } from "../ui/button";

export default function FloatingActionMenu() {
  const [showBackToTop, setShowBackToTop] = useState<boolean>(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setShowBackToTop(true);
    } else {
      setShowBackToTop(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div className="fixed bottom-20 right-6 z-50 flex flex-col gap-3">
      <div className="bg-white rounded-full shadow-lg border border-gray-200 p-2 flex flex-col gap-2">
        <AIChatbot variant="footer" />
        {showBackToTop && (
          <Button
            onClick={scrollToTop}
            id="back-to-top"
            className="h-10 w-10 rounded-full bg-accent text-white shadow-sm hover:bg-accent focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 transition-all duration-200 flex items-center justify-center p-0"
            aria-label="Back to top"
          >
            <ArrowUpIcon className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
